export const DEFAULT_VIDEO_CONSTRAINTS = {
    width: 1280,
    height: 720,
    frameRate: 24,
};

export const SELECTED_AUDIO_INPUT_KEY = 'SprelVisio-selectedAudioInput';
export const SELECTED_AUDIO_OUTPUT_KEY = 'SprelVisio-selectedAudioOutput';
export const SELECTED_VIDEO_INPUT_KEY = 'SprelVisio-selectedVideoInput';
